/**
 * confirmPromise - send custom confirm event that allows deeply nested components
 * to request confirmation on an action.
 *
 *
 * @param {*} message -- confirmation text
 * @returns {*} promise -- resolves with true/false
 */
export default function confirmPromise(path, message) {
  return new Promise((confirm) => {
    let detail = {message, confirm};
    let target = path.find(d => d.isConnected);
    let event = new CustomEvent('confirmation', {detail, bubbles: true, cancelable: true});
    console.log('dispatching', event, '->', target);
    if (target.dispatchEvent(event)) {
      // event not prevented, default to confirming using built-in
      confirm(window.confirm(message));
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/bubble/confirmPromise.js